import React, { useState } from "react";
import "./home.css";
import {
  Avatar,
  Col,
  Flex,
  Row,
  Card,
  Button,
  Rate,
  Tag,
  Carousel,
  Image,
  Space,
  Typography,
  List,
} from "antd";
import spatialImg from "../assets/images/spe-1.jpg";
import spatialTowImg from "../assets/images/spe-2.jpg";
import spatialThreeImg from "../assets/images/spe-3.jpg";
import bannerSlideImg from "../assets/images/banner-slide.jpg";
import ReviewSlider from "../components/ReviewSlider";
import { tours } from "../data/toursData";
import FAQAccordion from "../components/FAQAccordion";
import ExploreAttractions from "../components/ExploreAttractions";
import ExplorePlaces from "../components/ExplorePlaces";
import yellowBubble from "../assets/images/yellowBubble.svg";
import { ReactComponent as BuildingIcon } from "../assets/images/building.svg";
import { ReactComponent as FlightIcon } from "../assets/images/flight.svg";
import { ReactComponent as BeachIcon } from "../assets/images/beach.svg";
import { ReactComponent as TaxiIcon } from "../assets/images/taxi.svg";
import { ReactComponent as BagIcon } from "../assets/images/bag.svg";
import HotelCategoryChoose from "../components/HotelCategoryChoose";
import bannerSlide from "../assets/images/banner-slide.jpg";
import BookingForm from "../components/BookingForm";

const { Text, Paragraph, Title } = Typography;

const offers = [
  {
    img: spatialImg,
    title: "Up to 35% OFF (upto Rs.6,000)",
    desc: "On Domestic Hotels",
    note: "*Offers is Valid Only On Confirmed Hotel Bookings",
  },
  {
    img: spatialTowImg,
    title: "Up to 35% OFF (upto Rs.6,000)",
    desc: "On Domestic Hotels",
    note: "*Offers is Valid Only On Confirmed Hotel Bookings",
  },
  {
    img: spatialThreeImg,
    title: "Up to 35% OFF (upto Rs.6,000)",
    desc: "On Domestic Hotels",
    note: "*Offers is Valid Only On Confirmed Hotel Bookings",
  },
];

const termsAndConditions = [
  "Travel anytime until 31.03.2026.",
  "Public Holidays Period is excluded.",
  "Departure During High Season supplement (Aug): AED 290 per person.",
  "Departure During High Season supplement (05 December 2025 – 06 January 2026): AED 390 per person.",
  "Infant Fee: AED 300.",
  "Blackout Dates: 18th till 22nd of September 2025.",
  "Your requested travel dates are guaranteed. In the unlikely event that seats sell out, we will offer alternative travel dates within ±2 days of your preferred departure date.",
  "Submit your travel dates at least 5 days before your intended departure. For example, if you submit your dates on September 1, the earliest possible travel date will be September 6.",
  "For travel within the next 5 days, please use our real-time booking platform [IDA], click here.",
  "Visa on Arrival for most nationalities with valid UAE residency. Passport must be valid for 123 days and residence visa for 183 days upon arrival. For more info click here.",
  "Unredeemed vouchers can be cancelled for a minimal fee of only AED 250 per voucher.",
  "For the complete Terms and Conditions, click here.",
];

const DealPageFlightHotelPage = () => {
  const [selectedTour, setSelectedTour] = useState(tours[0]);
  // Store selected by ID instead of index
  const [selectedTourId, setSelectedTourId] = useState(tours[0].id);

  // Find active tour
  const activeTour = tours.find((t) => t.id === selectedTourId);

  const allINOne = [
    {
      icon: <BuildingIcon className="w-14 h-14 text-gray-500" />,
      title: "Handpicked Hotels",
      detail: "Stay in carefully selected 4 & 5-star hotels",
    },
    {
      icon: <FlightIcon className="w-14 h-14 text-gray-500" />,
      title: "Handpicked Hotels",
      detail: "Stay in carefully selected 4 & 5-star hotels",
    },
    {
      icon: <BeachIcon className="w-14 h-14 text-gray-500" />,
      title: "Handpicked Hotels",
      detail: "Stay in carefully selected 4 & 5-star hotels",
    },
    {
      icon: <TaxiIcon className="w-14 h-14 text-gray-500" />,
      title: "Handpicked Hotels",
      detail: "Stay in carefully selected 4 & 5-star hotels",
    },
    {
      icon: <BagIcon className="w-14 h-14 text-gray-500" />,
      title: "Handpicked Hotels",
      detail: "Stay in carefully selected 4 & 5-star hotels",
    },
  ];

  return (
    <>
      <section className="">
        <Carousel autoplay dots>
          <div>
            <div className="relative w-full h-[500px]">
              {/* Background Image */}
              <img
                src={bannerSlideImg}
                alt="Banner"
                className="w-full h-full object-cover"
              />

              {/* Overlay */}
              <div className="absolute inset-0 bg-[#2A2D35] opacity-30 shadow-[0_0_9px_rgba(0,0,0,0.25)]"></div>

              <div className="container">
                {/* Optional content on top */}
                <div className="absolute inset-0 flex items-center justify-center text-white">
                  <Flex align="center" justify="space-between">
                    <div className="w-[60%]">
                      <div className="bg-white text-danger px-2 py-1 text-xl font-bold inline-block mb-3">
                        SPRING & SUMMER DEAL
                      </div>
                      <h2
                        className="text-5xl font-bold leading-tight"
                        style={{
                          textShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
                        }}
                      >
                        Riga, Stockholm & Copenhagen
                      </h2>
                      <p
                        className="mt-2 text-2xl"
                        style={{
                          textShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
                        }}
                      >
                        Crazy Limited-Period Offers
                        <br />
                        No Hidden Charges. Pure Fun.
                      </p>
                    </div>
                    {/* Content */}
                    <div className="w-[40%] relative">
                      <fieldset class="w-full mt-8 border border-white/70 border-solid rounded-[4px] p-6 text-white inline-block relative">
                        <legend class="px-4 w-auto text-xl font-semibold !mb-0 text-center">
                          Limited Deal for YOU!
                        </legend>

                        <Title level={5} className="!mb-0 text-left">
                          <div className="text-3xl font-bold text-white">
                            INR 1,43,200
                            <span className="line-through font-normal text-2xl ml-2">
                              INR 2,65,185
                            </span>
                          </div>
                          <div className="font-normal mt-1 text-white text-lg">
                            SAVE INR 1,21,985
                          </div>
                          <div className="text-yellow-300 font-medium mt-2">
                            Travel Anytime Until 31st October 2025
                          </div>
                          <Button
                            type="danger"
                            size="middle"
                            className="mt-4 font-medium flex-1 px-12 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] bg-danger hover:bg-red-700 border-none rounded-md text-white"
                          >
                            Book Now
                          </Button>
                        </Title>
                      </fieldset>

                      {/* Discount Badge */}
                      <div
                        className="p-3 absolute border-white border-2 top-6 -right-6 bg-danger text-white font-bold 
                    text-sm  rounded-full flex items-center shadow-[0px_4px_6px_1px_rgba(0,0,0,0.25)]"
                      >
                        <div className="leading-tight">
                          <div className="text-2xl font-extrabold">50%</div>
                          <div>OFF</div>
                        </div>
                      </div>

                      {/* Grab Now Badge */}

                      <div
                        style={{ backgroundImage: `url(${yellowBubble})` }}
                        className="absolute bg-contain -bottom-16 -right-16 
                      text-white font-bold 
                      text-3xl w-40 h-40 bg-no-repeat flex items-center justify-center text-center flex-col"
                      >
                        <span className="text-base font-medium">GRAB DEAL</span>{" "}
                        NOW!
                      </div>
                    </div>
                  </Flex>
                </div>
              </div>
            </div>
          </div>
        </Carousel>
      </section>

      <section className="py-6 pt-16 px-4 lg:px-0">
        <div className="container">
          <div className="flex align-middle items-center mb-12 font-medium">
            <div>
              <Flex gap={15} align="center">
                <Title
                  className="!font-medium !text-danger !text-3xl !mb-1"
                  level={2}
                >
                  <span className="text-primary">All in </span> One Price
                </Title>
                <div className="text-3xl font-bold">
                  INR 1,43,200
                  <span className="line-through font-normal text-2xl ml-2">
                    INR 2,65,185
                  </span>
                </div>
              </Flex>
              <Paragraph className="!mb-0">
                Culture, nature, thrills, and record-breaking experiences
              </Paragraph>
            </div>
          </div>
          <Row gutter={[15, 20]}>
            {allINOne.map((item) => {
              return (
                <Col xs={12}>
                  <Flex align="center" gap={15}>
                    <Avatar size={105} className="bg-[#F7F7F7]">
                      {" "}
                      <span className="text-[24px] w-1/2 h-1/2 text-gray-500">
                        {item.icon}
                      </span>{" "}
                    </Avatar>
                    <div>
                      <h1 className="text-2xl font-medium">{item.title}</h1>
                      <p className="text-xl font-medium text-[#8C95A7]">
                        {item.detail}
                      </p>
                    </div>
                  </Flex>
                </Col>
              );
            })}
          </Row>
        </div>
      </section>

      <section className="py-6 px-4 lg:px-0">
        <HotelCategoryChoose />
      </section>

      <section className="py-6 px-4 lg:px-0">
        <div className="w-full h-60 relative overflow-hidden">
          {/* Gradient Overlay */}
          <div className="absolute inset-0 z-10 bg-[linear-gradient(270deg,_rgba(0,0,0,0)_0%,_#000000_100%)] pointer-events-none"></div>

          {/* Centered Image */}
          <Image
            preview={false}
            src={bannerSlide}
            className="!w-screen !h-60 object-cover object-[center_50%]"
          />

          <div className="container">
            <div className="py-8 text-white absolute top-0 z-20">
              <div className="font-medium text-3xl mb-2">
                Spring & Summer Deal valid for travel anytime until{" "}
              </div>
              <Flex align="center" gap={80}>
                <div className="font-semibold text-5xl text-yellow-300">
                  31st August 2025.
                  <Paragraph className="text-white text-2xl font-medium !mb-0">
                    Learn How To Request Your Travel Dates 
                  </Paragraph>
                </div>

                <div
                  style={{ backgroundImage: `url(${yellowBubble})` }}
                  className="bg-contain -bottom-16 -right-16 
                      text-white font-bold 
                      text-3xl w-40 h-40 bg-no-repeat flex items-center justify-center text-center flex-col"
                >
                  <span className="text-base font-medium">GRAB DEAL</span> NOW!
                </div>
              </Flex>
            </div>
          </div>
        </div>
      </section>

      <section className="py-6 px-4 lg:px-0">
        <BookingForm />
      </section>
      {/* Family </span>  Fun */}
      <section className="py-6 pt-16 px-4 lg:px-0">
        <div className="container">
          <Flex gap={15} align="center" justify="center">
            <Title
              className="!font-medium !text-danger !text-3xl !mb-1"
              level={2}
            >
              <span className="text-primary">Terms & Conditions </span>
            </Title>
          </Flex>

          <List
            size="large"
            bordered={false}
            dataSource={termsAndConditions}
            renderItem={(item, index) => (
              <List.Item className="text-base font-medium !border-none">
                {" "}
                {index + 1}. {item}
              </List.Item>
            )}
            className="py-8"
          />
        </div>
      </section>

      <section className="py-6">
        <ReviewSlider />
      </section>
    </>
  );
};

export default DealPageFlightHotelPage;
